module.exports = __webpack_public_path__ + "img/404.b46711d5.png";